module.exports = __webpack_public_path__ + "img/gigwi.132afa11.jpg";